import { Box, Typography } from '@mui/material';
import { FC } from 'react';
import { AmountAndCurrency } from 'ui/AmountAndCurrency';
import { TAmountWithQuantityProps } from './types';

export const AmountWithQuantity: FC<TAmountWithQuantityProps> = ({
	amount,
	quantity,
	paymentCurrency,
	name,
	total,
}) => {
	return (
		<Box
			sx={{
				display: 'flex',
				flexDirection: 'row',
				justifyContent: 'space-between',
				gap: 4,
				ml: 4,
			}}
		>
			<Box
				sx={{
					display: 'flex',
					flexDirection: 'row',
					gap: 1,
				}}
			>
				<Typography variant="body2" color="text.secondary">
					{name}
				</Typography>
			</Box>
			<Box
				sx={{
					display: 'flex',
					gap: 1,
				}}
			>
				<Typography
					variant="body2"
					sx={{
						fontSize: '.8rem',
					}}
					color="text.secondary"
				>
					<AmountAndCurrency amount={amount} currency={paymentCurrency ?? 'EUR'} size={0.8} />
					&nbsp;&times;&nbsp;{quantity}&nbsp;=&nbsp;
				</Typography>
				<AmountAndCurrency
					amount={amount * quantity}
					currency={paymentCurrency ?? 'EUR'}
					size={0.9}
					bold
					color="text.secondary"
				/>
			</Box>
		</Box>
	);
};
